import React, { ReactNode } from 'react';
interface ICheckType {
  type: 'string' | 'number' | 'boolean' | 'object' | 'array';
  arg: unknown;
  children?: ReactNode;
}
export const CheckType = (props: ICheckType) => {
  const { type, arg, children } = props;
  function checkType<T>(type: string, arg: T): ReactNode | null {
    if (type === 'array' && Array.isArray(arg)) {
      if (children) {
        return <>{children}</>;
      }
      return arg as ReactNode;
    }
    if (typeof arg === type) {
      if (children) {
        return <>{children}</>;
      }
      return arg as ReactNode;
    }
    return null;
  }
  return <>{checkType(type, arg)}</>;
};
